<template>
  <div class="about-us">
        <div class="head-part">
            <div class="head-text">
                <div class="page-title">700</div>
                <p >صرافی 700 از اولین صرافی‌های ارز دیجیتال ایرانی است. این صرافی با ارائه خدمات متنوع و پشتیبانی 24 ساعته، پلتفرمی امن برای مبادلات ارزهای دیجیتال است. چهار سال سابقه در حوزه کریپتوکارنسی، 700 را به یکی از پیشگامان و اثر گذاران بر بازار داخلی ارزهای دیجیتال در ایران تبدیل کرده است. نوتیبای، یک پلتفرم آنلاین برای خرید و فروش ارزهای دیجیتال است. این صرافی به‌عنوان یک واسطه میان خریداران و فروشندگان ارزهای دیجیتال عمل می‌کند. کاربران در نوتیبای با ارائه نرخ خرید و فروش مورد نظر خود با سایر کاربران اقدام به معامله می‌کنند      </p>
                <!-- <p >ﻟﻮرم اﭙﯾﺴﻮم ﻣﺘﻦ ﺳﺎﺧﺘﯽﮕ ﺑﺎ ﺗﻮﻟﯿﺪ ﺳﺎدﯽﮔ ﻧﺎﻣﻔﻬﻮم از ﺻﻨﻌﺖ ﭼﺎپ، و ﺑﺎ اﺳﺘﻔﺎده از ﻃﺮاﺣﺎن ﮔﺮاﻓﮏﯿ اﺳﺖ، ﭼﺎﮕﭘﺮﻫﺎ و ﻣﺘﻮن ﺑﻠﮑﻪ روزﻧﺎﻣﻪ و ﻣﺠﻠﻪ در ﺳﺘﻮن و ﺳﻄﺮآﻧﭽﻨﺎن ﮐﻪ ﻟﺎزم اﺳﺖ، و ﺑﺮای ﺷﺮاﯾﻂ ﻓﻌﻠﯽ ﺗﮑﻨﻮﻟﻮژی ﻣﻮرد ﻧﯿﺎز، و ﮐﺎرﺑﺮدﻫﺎی ﻣﺘﻨﻮع ﺑﺎ ﻫﺪف ﺑﻬﺒﻮد اﺑﺰارﻫﺎی ﮐﺎرﺑﺮدی ﻣﯽ ﺑﺎﺷﺪ، ﮐﺘﺎﺑﻬﺎی زﯾﺎدی در ﺷﺼﺖ و ﺳﻪ درﺻﺪ ﮔﺬﺷﺘﻪ ﺣﺎل و آﯾﻨﺪه، ﺷﻨﺎﺧﺖ ﻓﺮاوان ﺟﺎﻣﻌﻪ و ﻣﺘﺨﺼﺼﺎن را ﻣﯽ ﻃﻠﺒﺪ، ﺗﺎ ﺑﺎ ﻧﺮم اﻓﺰارﻫﺎ ﺷﻨﺎﺧﺖ ﺑﯿﺸﺘﺮی را ﺑﺮای ﻃﺮاﺣﺎن راﯾﺎﻧﻪ ای ﻋﻠﯽ اﻟﺨﺼﻮص ﻃﺮاﺣﺎن ﺧﻠﺎﻗﯽ، و ﻓﺮﻫﻨﯿﭘ ﮓﺸﺮو در زﺑﺎن ﻓﺎرﺳﯽ اﯾﺠﺎد ﮐﺮد، در اﯾﻦ ﺻﻮرت ﻣﯽ ﺗﻮان اﻣﯿﺪ داﺷﺖ ﮐﻪ ﺗﻤﺎم و دﺷﻮاری ﻣﻮﺟﻮد در اراﺋﻪ راﻫﮑﺎرﻫﺎ، و ﺷﺮاﯾﻂ ﺳﺨﺖ ﺗﺎﭗﯾ ﺑﻪ ﭘﺎﯾﺎن رﺳﺪ و زﻣﺎن ﻣﻮرد ﻧﯿﺎز ﺷﺎﻣﻞ ﺣﺮوﻓﯿﭽﻨﯽ دﺳﺘﺎوردﻫﺎی اﺻﻠﯽ، و ﺟﻮاﺑﮕﻮی ﺳﻮاﻟﺎت ﯿﭘﻮﺳﺘﻪ اﻫﻞ دﻧﯿﺎی ﻣﻮﺟﻮد ﻃﺮاﺣﯽ اﺳﺎﺳﺎ ﻣﻮرد اﺳﺘﻔﺎده ﻗﺮار ﯿﮔﺮد.       </p> -->
            </div>
            <div class="img-container head-img">
                <img src="../../assets/public/about-us.png" class="img"/>
            </div>
        </div>
        <div class="advantages-sec">
            <h3 class="advantages-title">امکانات و مزایای ما</h3>
            <div class="advantages-text"> امکانات و مزایای منحصربفرد باعث ایجاد تجربه ای متفاوت و امن در خرید و فروش بیت کوین و سایر ارز های دیجیتالی شده است</div>
            <div class="advantages">
                <div class="advantage">
                    <div class="advantage-title"> پشتیبانی سریع و 24 ساعته</div>
                      <div class="img-container">
                          <img src="../../assets/public/aboutus-person.png" class="img"/>
                     </div>
                </div> 
                <div class="advantage">
                    <div class="advantage-title">امنیت بالا معاملات</div>
                        <div class="img-container">
                          <img src="../../assets/public/aboutus-lock.png" class="img"/>
                     </div>
                </div>  
               <div class="advantage">
                    <div class="advantage-title">معلاملات سریع و حرفه ای</div>
                      <div class="img-container">
                          <img src="../../assets/public/aboutus-monitor.png" class="img"/>
                     </div>
                   
                </div>
               
            </div>


        </div>
        <div class="statistics">
            <div class="statistic">
                <div class="statistic-value">{{userscount.toLocaleString()}}</div>
                <div class="statistic-label">کاربر فعال</div>
            </div>
            <div class="statistic">
                <div class="statistic-value">{{totaltrad.toLocaleString()}}</div>
                <div class="statistic-label">معامله‌ی انجام شده</div>
            </div>
            <div class="statistic">
                <div class="statistic-value">{{$toLocal(tradprice,0)}}</div>
                <div class="statistic-label">ارزش کل معاملات</div>
            </div>

        </div>
        <p class="text">با بررسی بخش بازارها در وب‌سایت 700 می‌توانید از قیمت‌ لحظه‌ای ارزهای دیجیتال معتبر و محبوب جهانی که در نوتیبای عرضه شده‌اند باخبر شوید. قیمت‌ها در نوتیبای به صورت لحظه‌ای بر پایه بازار تتر (دلاری) و تومان قابل مشاهده است.</p>
        <p class="text">700 در حال حاضر نزدیک به 40 کوین معتبر دنیا از جمله بیت کوین (BTC) ، اتریوم (ETH) ، تتر(USDT) ، دوج کوین (DOGE) ، شیبا (SHIB) و بسیاری دیگر از توکن‌های محبوب را در پلتفرم معاملاتی خود دارد. امکان معامله این توکن‌ها بر دو پایه بازار ریالی، تتری با سایر کاربران وجود دارد. </p>
        <!-- <p class="text">ﻟﻮرم اﭙﯾﺴﻮم ﻣﺘﻦ ﺳﺎﺧﺘﯽﮕ ﺑﺎ ﺗﻮﻟﯿﺪ ﺳﺎدﯽﮔ ﻧﺎﻣﻔﻬﻮم از ﺻﻨﻌﺖ ﭼﺎپ، و ﺑﺎ اﺳﺘﻔﺎده از ﻃﺮاﺣﺎن ﮔﺮاﻓﮏﯿ اﺳﺖ، ﭼﺎﮕﭘﺮﻫﺎ و ﻣﺘﻮن ﺑﻠﮑﻪ روزﻧﺎﻣﻪ و ﻣﺠﻠﻪ در ﺳﺘﻮن و ﺳﻄﺮآﻧﭽﻨﺎن ﮐﻪ ﻟﺎزم اﺳﺖ، و ﺑﺮای ﺷﺮاﯾﻂ ﻓﻌﻠﯽ ﺗﮑﻨﻮﻟﻮژی ﻣﻮرد ﻧﯿﺎز، و ﮐﺎرﺑﺮدﻫﺎی ﻣﺘﻨﻮع ﺑﺎ ﻫﺪف ﺑﻬﺒﻮد اﺑﺰارﻫﺎی ﮐﺎرﺑﺮدی ﻣﯽ ﺑﺎﺷﺪ، ﮐﺘﺎﺑﻬﺎی زﯾﺎدی در ﺷﺼﺖ و ﺳﻪ درﺻﺪ ﮔﺬﺷﺘﻪ ﺣﺎل و آﯾﻨﺪه، ﺷﻨﺎﺧﺖ ﻓﺮاوان ﺟﺎﻣﻌﻪ و ﻣﺘﺨﺼﺼﺎن را ﻣﯽ ﻃﻠﺒﺪ، ﺗﺎ ﺑﺎ ﻧﺮم اﻓﺰارﻫﺎ ﺷﻨﺎﺧﺖ ﺑﯿﺸﺘﺮی را ﺑﺮای ﻃﺮاﺣﺎن راﯾﺎﻧﻪ ای ﻋﻠﯽ اﻟﺨﺼﻮص ﻃﺮاﺣﺎن ﺧﻠﺎﻗﯽ، و ﻓﺮﻫﻨﯿﭘ ﮓﺸﺮو در زﺑﺎن ﻓﺎرﺳﯽ اﯾﺠﺎد ﮐﺮد، در اﯾﻦ ﺻﻮرت ﻣﯽ ﺗﻮان اﻣﯿﺪ داﺷﺖ ﮐﻪ ﺗﻤﺎم و دﺷﻮاری ﻣﻮﺟﻮد در اراﺋﻪ راﻫﮑﺎرﻫﺎ، و ﺷﺮاﯾﻂ ﺳﺨﺖ ﺗﺎﭗﯾ ﺑﻪ ﭘﺎﯾﺎن رﺳﺪ و زﻣﺎن ﻣﻮرد ﻧﯿﺎز ﺷﺎﻣﻞ ﺣﺮوﻓﯿﭽﻨﯽ دﺳﺘﺎوردﻫﺎی اﺻﻠﯽ،a و ﺟﻮاﺑﮕﻮی ﺳﻮاﻟﺎت ﯿﭘﻮﺳﺘﻪ اﻫﻞ دﻧﯿﺎی ﻣﻮﺟﻮد ﻃﺮاﺣﯽ اﺳﺎﺳﺎ ﻣﻮرد اﺳﺘﻔﺎده ﻗﺮار ﯿﮔﺮد.ﻟﻮرم اﭙﯾﺴﻮم ﻣﺘﻦ ﺳﺎﺧﺘﯽﮕ ﺑﺎ ﺗﻮﻟﯿﺪ ﺳﺎدﯽﮔ ﻧﺎﻣﻔﻬﻮم از ﺻﻨﻌﺖ ﭼﺎپ، و ﺑﺎ اﺳﺘﻔﺎده از ﻃﺮاﺣﺎن ﮔﺮاﻓﮏﯿ اﺳﺖ، ﭼﺎﮕﭘﺮﻫﺎ و ﻣﺘﻮن ﺑﻠﮑﻪ روزﻧﺎﻣﻪ و ﻣﺠﻠﻪ در ﺳﺘﻮن و ﺳﻄﺮآﻧﭽﻨﺎن ﮐﻪ ﻟﺎزم اﺳﺖ، و ﺑﺮای ﺷﺮاﯾﻂ ﻓﻌﻠﯽ ﺗﮑﻨﻮﻟﻮژی ﻣﻮرد ﻧﯿﺎز، و ﮐﺎرﺑﺮدﻫﺎی ﻣﺘﻨﻮع ﺑﺎ ﻫﺪف ﺑﻬﺒﻮد اﺑﺰارﻫﺎی ﮐﺎرﺑﺮدی ﻣﯽ ﺑﺎﺷﺪ، ﮐﺘﺎﺑﻬﺎی زﯾﺎدی در ﺷﺼﺖ و ﺳﻪ درﺻﺪ ﮔﺬﺷﺘﻪ ﺣﺎل و آﯾﻨﺪه، ﺷﻨﺎﺧﺖ ﻓﺮاوان ﺟﺎﻣﻌﻪ و ﻣﺘﺨﺼﺼﺎن را ﻣﯽ ﻃﻠﺒﺪ، ﺗﺎ ﺑﺎ ﻧﺮم اﻓﺰارﻫﺎ ﺷﻨﺎﺧﺖ ﺑﯿﺸﺘﺮی را ﺑﺮای ﻃﺮاﺣﺎن راﯾﺎﻧﻪ ای ﻋﻠﯽ اﻟﺨﺼﻮص ﻃﺮاﺣﺎن ﺧﻠﺎﻗﯽ، و ﻓﺮﻫﻨﯿﭘ ﮓﺸﺮو در زﺑﺎن ﻓﺎرﺳﯽ اﯾﺠﺎد ﮐﺮد، در اﯾﻦ ﺻﻮرت ﻣﯽ ﺗﻮان اﻣﯿﺪ داﺷﺖ ﮐﻪ ﺗﻤﺎم و دﺷﻮاری ﻣﻮﺟﻮد در اراﺋﻪ راﻫﮑﺎرﻫﺎ، و ﺷﺮاﯾﻂ ﺳﺨﺖ ﺗﺎﭗﯾ ﺑﻪ ﭘﺎﯾﺎن رﺳﺪ و زﻣﺎن ﻣﻮرد ﻧﯿﺎز ﺷﺎﻣﻞ ﺣﺮوﻓﯿﭽﻨﯽ دﺳﺘﺎوردﻫﺎی اﺻﻠﯽ، و ﺟﻮاﺑﮕﻮی ﺳﻮاﻟﺎت ﯿﭘﻮﺳﺘﻪ اﻫﻞ دﻧﯿﺎی ﻣﻮﺟﻮد ﻃﺮاﺣﯽ اﺳﺎﺳﺎ ﻣﻮرد اﺳﺘﻔﺎده ﻗﺮار ﯿﮔﺮد. </p> -->
        
   
  </div>
</template>

<script>
export default {
  name: 'AboutUs',
  props: {
    msg: String
  },
    data(){
      return{
           userscount: '0',
            tradprice: '0',
            totaltrad: '0'
      }
  },
   methods: {
        async getInfo() {
            const res = await this.$axios('trades/market-info-home')
            this.userscount = res.baseDTO.userCount
            this.tradprice = res.baseDTO.tradesValue
            this.totaltrad = res.baseDTO.tradesAmount
        }
    },
    mounted() {
        this.getInfo()
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.advantages{
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-top: 40px;
    row-gap: 30px;
    justify-content: space-evenly;
}
.advantages-sec{
    align-items: center;
    display: flex;
    flex-grow: 1;
    width: 85%;
    max-width: 990px;
    flex-direction: column;
}
.about-us{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 60px;
    margin-bottom: 100px;
}

.page-title{
    color: #FFBF00;
    font-size: clamp(30px,4.5vw,64px);
}

.advantages-title{
    color: #FFBF00;
    font-size: clamp(24px,3vw,36px);
    font-weight: bold;
}
.statistic{
    display: flex;
    height: 200px;
    row-gap:24px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.statistic-label{
    font-size: clamp(20px,2.2vw,24px);
    color:var(--aboutus-statistic-label);
    color:#FFBF00;
}

.statistic-value{
    font-size: clamp(28px,3vw,36px);
    font-weight: bold;
    color:var(--aboutus-statistic-value)

}

.statistics{
    display: flex;
    justify-content: space-around;
    background: var(--aboutus-section-bg);
    flex-wrap: wrap;
    padding: 0px 40px;
    width: 100%;
    margin-top:45px;
    margin-bottom: 70px;
}
.head-text{
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-top: 50px;
    font-size: clamp(12px,1.3vw,14px);
    flex-basis:300px;
    color:var(--aboutus-head-text);
    row-gap: 24px;
}

.advantages-text{
    color:var(--aboutus-advantages-text);
    font-size: clamp(14px,1.5vw,16px);
    font-weight: 300;
}

.head-part{
    display: flex;
    width: 85%;
    flex-wrap: wrap;
    align-items: flex-start;
}

.head-img{
    margin-top: 60px;

}

.advantage-title{
    color:var(--aboutus-advantage-title);
    font-weight: bold;
    font-size: clamp(16px,1.7vw,18px);
}
.advantage{
    background: var(--aboutus-section-bg);
    display: flex;
    // padding: 40px 50px 50px 50px;
    border-radius:30px;
    width: 100%;
    row-gap: 40px;
    justify-content: center;
    max-width: 300px;
    height: 400px;
    flex-direction: column;
    align-items: center;
}

.img-container > img{
   width: 100%;
  

}
.img-container{
   
    
    min-width: 150px;
   
}

.text{
    width: 85%;

    color:var(--aboutus-text);
    font-size: clamp(11px,1.3vw,12px);
}
</style>
